var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.name)?_c('svg',{class:_vm.className,attrs:{"xmlns":"http://www.w3.org/2000/svg"}},[_c('use',{attrs:{"xlink:href":'#' + _vm.name + '--sprite',"xmlns:xlink":"http://www.w3.org/1999/xlink"}}),_vm._v(" "+_vm._s(_vm.getSvg)+" ")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }